import axios from '@/axios.js'

const getResortFacilities = async (params, page) => {
    try {
        const response = await axios.editorapi.get(`/v4/resorts/${params.resort_uuid}/facilities/no-cache?q=${params.q}&page=${page}`);
        return response.data.object
    } catch (error) {
        throw new Error(error)
    }
}

const createResortFacility = async (resortUuid, payload) => {
    return axios.editorapi.post(`/v4/resorts/${resortUuid}/facilities`, payload)
}

const updateResortFacility = async (resortUuid, facilityUuid, payload) => {
    const response = await axios.editorapi.patch(`/v4/resorts/${resortUuid}/facilities/${facilityUuid}`, payload)
    return response.data
}

const deleteResortFacility = async (resortUuid, facilityUuid) => {
    const response = await axios.editorapi.delete(`/v4/resorts/${resortUuid}/facilities/${facilityUuid}`)
    if (response.status !== 200) {
        return response
    }
    return response.data
}
export default {
    getResortFacilities,
    createResortFacility,
    updateResortFacility,
    deleteResortFacility
}